<template>
    <SwapMenu2 swapid="ALL" :period="period" title="SWAP TABLE" margin="1">
    <template v-slot:menu>
      <li><a v-if="interval == 0" 
            class="dropdown-item" @click=start_interval()>START Interval</a></li>
      <li><a v-if="interval > 0" 
            class="dropdown-item" @click=stop_interval()>STOP Interval</a></li>
      <li><a v-if="swapcontrol > 0" class="dropdown-item" @click=stop_swaps()>STOP Swaps</a></li>
      <li><a v-if="swapcontrol > 0" class="dropdown-item" @click=start_swaps()>START Swaps</a></li>
      <li><a v-if="swapcontrol > 0" class="dropdown-item" @click=clear_mark()>CLEAR Marks</a></li>
      <li><a v-if="swapcontrol > 0" class="dropdown-item" @click=set_mark()>MARK ALL</a></li>
    </template>
    </SwapMenu2>
    <div class="table-responsive" style="height:80%">
        <table style="" class="table table-striped table-bordered">
            <thead>
                <tr>
                    <th>MARK</th>
                    <th v-for="c in headers" :key="c"> {{ c }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="cols in swapdata" :key="cols[0]" 
                    title="click for detail info" 
                    @click="swapinfo(cols[0])">

                     <td><input type="checkbox" :value="cols[0]" @click="do_checkbox(cols[0])"
                          v-model="rowselected[cols[0]]"/></td>

                    <td v-for="c in cols" :key="c" class="colpad">
                       {{ c }}</td>
                </tr>
            </tbody>
        </table>
    </div>    
</template>

<style scoped>
th {
   padding : 0px ;
   background : #B0B0FF ;
}
.font-custom {
    font-size : 10pt ;
    text-align: left ;
}
.colpad {
    padding: 0.1rem !important ;
}
.divstyle {
    font-size : 10pt ;
    max-height: auto ;
    overflow-y: auto;
    margin-top: 0px ;
}
.aligncenter {
    text-align: center ;
}
</style>

<script>
import SwapMenu2 from './SwapMenu2.vue' 
import txdatatab from '../assets/txdata.json'
import axios from 'axios' 

export default {
  name: 'BarChart',
  components: {
      SwapMenu2 
  },
  mounted() {
     this.start_interval();
  },
  unmounted() {
     this.stop_interval();
  },
  data() {
    return {
        rowselected : { },
        interval: 0,
        outframe : null
    }
  },
  props: {
    period : Number,
    screensize : String,
    display : Object
  },
  computed : {
      swapid() {
        return this.$store.getters.controllerid ;
      },
      swapcontrol() {
        return this.$store.getters.swapcontrol ;
      },
      widthclass() {
        if (this.screensize.length == 3)
            return this.screensize.substr(2) ;
        else return "1" ;
      },
      heightclass() {
        if (this.screensize.length == 3)
            return this.screensize.substr(0,1) ;
        else return "1" ;
     },
     headers() {
        let cols = [ "PSWLINE", "NAME" ]
        for (let i = 0 ; i < this.display.length ; i++) {
           cols[i + 2] = txdatatab[ this.display[i] ]  ;
        }
        return cols ;
     },
     swapdata() {
        let data = [] ;
        for (let i = 0 ; i < this.$store.state.swaps.length ;i++) {
          let swap = this.$store.state.swaps[i] ;
          if (swap && swap.pswline) {
              let cols = [ swap.pswline, swap.name.substr(0,12) ] ;
              for (let i = 0 ; i < this.display.length ; i++) {
                if (! swap.sdata || ! swap.sdata.txdata )
                   cols[i + 2] = "null" ;
                else
                   cols[i + 2] = swap.sdata.txdata[ this.display[i] ] ;
              }
              data.push ( cols )  ;
          }
        }
        return data ;
      }
  },
  methods : {
      clear_mark() {
        let datas = this.swapdata ;
        for (let cols of datas) {
           this.rowselected[ cols[0] ] = false ;
        }
      },
      set_mark() {
        let datas = this.swapdata ;
        for (let cols of datas) {
           this.rowselected[ cols[0] ] = true ;
        }
      },
      start_swaps() {
        this.openframe() ;
        let datas = this.swapdata ;
        for (let cols of datas) {
           if (! this.rowselected[ cols[0] ] )
               continue ;
           let swap = this.$store.getters.getswap_byid(cols[0]) ;
           if (! swap || !swap.sdata || ! swap["speedo"] )
              this.runcmd ('swap_start.sh', cols[0]) ;
           else
              this.writearea ("swap " + cols[0] + " already UP !<br>") ;
        }
        if (this.outframe) this.outframe.close() ;
      },
      stop_swaps() {
        this.openframe() ;
        let datas = this.swapdata ;
        for (let cols of datas) {
           if (! this.rowselected[ cols[0] ] )
               continue ;
           let swap = this.$store.getters.getswap_byid(cols[0]) ;
           if (! swap || !swap.sdata || ! swap["speedo"] )
              this.writearea ("swap " + cols[0] + " already DOWN!<br>") ;
           else
              this.runcmd ('swap_stop.sh', cols[0]) ;
        }
        if (this.outframe) this.outframe.close() ;
      },
      do_checkbox(pswline) {
          // alert ("select pswline:" + pswline + " row " + idx)  ;
          if (! this.rowselected[pswline]) 
            this.rowselected[pswline] = true ;
          else
            this.rowselected[pswline] = false ;
      },
      swapinfo(pswline) {
        if (! document.getElementById("IFRAME01")) 
            return ;
        this.$store.state.rootel.swapinfo(pswline) ;
      },
      stop_interval() {
         if (this.interval) {
            clearInterval(this.interval) ;
            this.interval = 0 ;
         }
      },
      start_interval() {
         if (this.interval == 0) {
            this.interval = setInterval( () => 
                 this.$store.commit("getswapdata"),this.period) ;
         }
      },
      openframe() {
        let frame1 = this.$store.state.rootel.getframe() ;
        this.outframe = null ;
        if (frame1) {
           this.outframe = frame1.contentWindow.document ;
           this.outframe.open() ;
        }
      },
      writearea(s) {
        if (this.outframe)
            this.outframe.write(s);
        else
            console.log(s) ;
      },
      runcmd(cmd, swapid) {    // toggle start or stop swap
        this.writearea ("Please Wait Excecuting " + cmd + " SWAPID: " + swapid) ;
        let req = "" ;
        try {
                    req = this.$store.getters.controller_url +
                    "/prosw/exec/x/" + cmd + "?" + "swapid=" + swapid ;
        }
        catch(err) {
                    console.log(err) ;
                    return ;
        }
        axios.get (req,  {
                    timeout: 20000,
                    responseType: 'text', 
                    headers: {'Pswtoken': this.$store.getters.pswtoken }
        }).then ( (response) => {
                  let res = response.data ;
                  if (typeof res == "object")
                    this.writearea(JSON.stringify(res)) ;
                  else 
                    this.writearea("<pre>" + response.data + "</pre>") ;
                  }
        ).catch ( (error) => { 
                    this.writearea ("REQUEST TIMEMOUT") ;
                    if (error.code === 'ECONNABORTED') 
                       console.log('Request timed out');
                    else 
                       console.log(error.message);
                })
        }
  }
}
// vim:expandtab:smartindent:tabstop=4:softtabstop=4:shiftwidth=4:
</script>


